<template>
  <div class="otp-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>One Time Password</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body div-responsive">
            <div class="box-body">
              <div class="box-row">
                <div class="box-col box-col-left">OTP from Authenticator Application</div>
                <div class="box-col box-col-right">
                  <input type="password" class="password" :class="hasError && !validatePassword ? 'is-invalid' : ''" v-model="password" placeholder="Password" />
                  <div class="text-danger" v-if="hasError && !validatePassword">
                    Please enter OTP
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                    <v-btn @click="clickSave" dark>Submit</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import auth from '@/assets/js/cognitoAuth'
  import { touchLastActivityAt } from '@/assets/js/idleMonitor'

  export default {
    name: 'OTPModal',
    props: [],
    data() {
      return {
        popups: [],
        loadModal: false,
        user: {},
        hasError: false,
        password: '',
      }
    },

    computed: {
      validatePassword() {
        return this.password !== ''
      },
    },

    methods: {
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
          this.password = ""
          setTimeout(() => {
            $(".otp-modal .password").focus()
          }, 500)
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },
      showAlert(index) {
        this.$alert(this.popups[index].Message, this.popups[index].Title, {
          confirmButtonText: 'OK',
          callback: () => {
            if(index < this.popups.length - 1) {
              const indexNew = index + 1
              this.showAlert(indexNew)
            }
          }
        })
      },
      async clickSave() {
        this.hasError = false
        if (!this.validatePassword) {
          this.hasError = true
          return
        }

        await this.$store.dispatch('loading/setLoadComponent', true)
        try {
          auth.verifyOtp(this.user, this.password).then(async (user) => {
            console.log(user)
            //Save Authentication details after login
            var authentication = utilities.loadAuthentication(user.signInUserSession)
            await this.$store.dispatch('user/setAuthentication', authentication)
            touchLastActivityAt()

            let userToSave = await utilities.getUserBySub(user.signInUserSession.accessToken.payload['sub'])
            this.$parent.userToSave = userToSave
            if (userToSave) {
              // Zoho Integration
              // fetch('https://vtjfl2u95a.execute-api.ap-southeast-2.amazonaws.com/RHOReferenceData/zoho-login').then((response) => console.log(response))
              await this.$store.dispatch('user/setUser', userToSave)
              if(userToSave.type === 7) {
                try {
                  const res = await utilities.getPracticeManagerProfile()
                  const specialists = res.Specialists
                  if(specialists.find(item => item.PracticeManagerSpecialist.Selected)) {
                    await this.$store.dispatch('user/setUser', {...userToSave, specialistId: specialists.find(item => item.PracticeManagerSpecialist.Selected).SpecialistID, list: specialists} )
                    var result = await this.$parent.setLastLoginDate(userToSave)
                    await this.$store.dispatch('loading/setLoadComponent', false)
                    if(result) this.$parent.redirectToHome()
                    return
                  } else {
                    await this.$store.dispatch('loading/setLoadComponent', false)
                    this.$parent.specialists = specialists
                    this.$parent.showSelectModal = true
                    this.handleModal()
                    return
                  }
                } catch (e) {
                  console.log('----------------------error------------------')
                  console.log(e)
                  return
                }
              }
              if (userToSave.type <= 2) {
                this.popups = await utilities.getClientPopups(userToSave.clientId)
                await this.$store.dispatch('loading/setLoadComponent', false)
                if(this.popups.length > 0) {
                  this.showAlert(0)
                }
              }
              await this.$store.dispatch('loading/setLoadComponent', false)
              await this.$store.dispatch('loading/setLoadComponent', true)
              var result = await this.$parent.setLastLoginDate(userToSave)
              if(result) this.$parent.redirectToHome()
            } else {
              console.log(userToSave)
            }
            this.$store.dispatch('loading/setLoadComponent', false)
          }).catch(e => {
            this.$store.dispatch('loading/setLoadComponent', false)
            utilities.showErrorMessage(e.message)
          })
        } catch (e) {
          this.hasError = true
          utilities.showErrorMessage(e.message)
          this.$store.dispatch('loading/setLoadComponent', false)
        }
      },
    },

    beforeMount() {},
    mounted() {},
  }
</script>
